import React, { useEffect, useState } from "react";
import Slot from "./Slot";
import SpecialSlots from "./SpecialSlots";
import { useLocation } from "react-router-dom";
import { post } from "../../../Services/ApiHandler";
import { BASE_URL, URL } from "../../../Services/Constant";
import { toast } from "react-toastify";
import moment from "moment/moment";
import { Modal } from "react-bootstrap";

const days_arr = [
  { day: "Monday", type: 1, start_time: "", end_time: "", toggle: false },
  { day: "Tuesday", type: 2, start_time: "", end_time: "", toggle: false },
  { day: "Wednesday", type: 3, start_time: "", end_time: "", toggle: false },
  { day: "Thursday", type: 4, start_time: "", end_time: "", toggle: false },
  { day: "Friday", type: 5, start_time: "", end_time: "", toggle: false },
  { day: "Saturday", type: 6, start_time: "", end_time: "", toggle: false },
  { day: "Sunday", type: 7, start_time: "", end_time: "", toggle: false },
];

const SlotMain = () => {
  const [activeTab, setActiveTab] = useState("week");
  const [days, setDays] = useState([...days_arr]);
  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const location = useLocation();
  const superAdmin = location.state?.superAdmin;
  const [dates, setDates] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [option, setOption] = useState(null);
  const [siteList, setSiteList] = useState([]);
  const [fileUpload, setFileUpload] = useState("");
  const [selectedDays, setSelectedDays] = useState([]);

  const handleClose = () => {
    setShowPopup(false);
  };
  // console.log("superAdmin", superAdmin);

  // useEffect(() => {
  //   const slotDays = JSON.parse(localStorage.getItem("slotDays"));
  //   if (slotDays) {
  //     setActiveTab(slotDays);
  //   } else {
  //     setActiveTab("week");
  //     localStorage.setItem("slotDays", JSON.stringify("week"));
  //   }
  // }, []);

  const handleCheckboxChange = (dayType) => {
    setSelectedDays((prev) => {
      if (prev.includes(dayType)) {
        return prev.filter((d) => d !== dayType);
      } else {
        return [...prev, dayType];
      }
    });
  };

  const handleTab = (days) => {
    setActiveTab(days);
    localStorage.setItem("slotDays", JSON.stringify(days));
  };

  const getDayList = (currentDayIndex = 0) => {
    let formdata = new FormData();
    formdata.append("knf_company_site_id", user_details?.knf_company_site_id);
    post(URL.DAY_LIST, formdata)
      .then((res) => {
        if (res?.data?.length > 0) {
          let temp = [...days_arr];
          let data = [...res?.data];
          let day_type = [1, 2, 3, 4, 5, 6, 7];
          data?.map((item) => {
            if (day_type?.includes(item?.type)) {
              let indexToReplace = day_type.findIndex((i) => i === item?.type);
              temp[indexToReplace] = {
                ...temp[indexToReplace],
                toggle: item?.start_time && item?.end_time ? true : false,
                start_time: item?.start_time
                  ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
                  : "",
                end_time: item?.end_time
                  ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
                  : "",
              };
            }
          });

          // ✅ Use the currently active day index, not always the first
          const activeDay = temp[currentDayIndex];
          if (activeDay?.start_time && activeDay?.end_time) {
            const matchingDays = temp
              .filter(
                (d) =>
                  d.type !== activeDay.type &&
                  d.start_time === activeDay.start_time &&
                  d.end_time === activeDay.end_time,
              )
              .map((d) => d.type);
            setSelectedDays(matchingDays);
          } else {
            setSelectedDays([]); // ✅ No time set = no checkboxes
          }

          setDays(temp);
        }
      })
      .catch((err) => console.log("err", err));
  };

  const getDateList = (knf_company_site_id, ind) => {
    let formdata = new FormData();
    formdata.append("knf_company_site_id", user_details?.knf_company_site_id);
    post(URL.DATE_LIST, formdata)
      .then((res) => {
        if (res?.data?.length > 0) {
          let temp = [];
          let data = [...res?.data];
          data?.map((item, ind) => {
            let obj = {
              ...item,
              toggle: item?.status === 1,
              date: item?.for_date,
              for_date: moment(item?.for_date).format("DD-MM-YYYY"),
              start_time: item?.start_time
                ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
                : "",
              end_time: item?.end_time
                ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
                : "",
            };
            temp.push(obj);
          });
          setDates(temp);
          if (ind) {
            setSelectedDate(temp?.[ind]?.id);
          } else {
            setSelectedDate(temp?.[0]?.id);
          }
        } else {
          setDates([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getDayList();
    getDateList(user_details?.knf_company_site_id);
  }, []);

  // const handleSubmit = (ind) => {
  //   let temp = [...days];
  //   let data = temp[ind];
  //   let arr = [data?.type, ...selectedDays];
  //   console.log("arrDataType", arr);
  //   let uniqueArr = [...new Set(arr)];
  //   console.log("uniqueArrType", uniqueArr);

  //   let payload = {
  //     knf_company_site_id: user_details?.knf_company_site_id,
  //     type: uniqueArr,
  //     start_time: data?.start_time,
  //     end_time: data?.end_time,
  //   };
  //   console.log("payload", payload);
  //   post(URL.SPECIAL_DAY_STORE, payload)
  //     .then((res) => {
  //       if (res?.status == "success") {
  //         toast.success(res?.message);
  //         getDayList();
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("err", err);
  //     });
  // };

  const handleSubmit = (ind) => {
    const currentDay = days[ind];

    const payload = {
      knf_company_site_id: user_details?.knf_company_site_id,
      slots: days.map((day) => {
        const isCurrentDay = day.type === currentDay.type;
        const isCopiedDay = selectedDays.includes(day.type);
        return {
          type: day.type,
          start_time:
            isCurrentDay || isCopiedDay
              ? currentDay.start_time
              : day.start_time || "",
          end_time:
            isCurrentDay || isCopiedDay
              ? currentDay.end_time
              : day.end_time || "",
          status: isCurrentDay || isCopiedDay || day.toggle ? 1 : 0,
        };
      }),
    };

    post(URL.SPECIAL_DAY_STORE, payload)
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res.message);

          // ✅ Preserve selectedDays before getDayList resets them
          const preservedSelectedDays = [...selectedDays];
          getDayList(ind);
          setSelectedDays(preservedSelectedDays); // ✅ Restore after getDayList clears it
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(err?.message || "Something went wrong");
      });
  };

  const handleDateSubmit = (ind) => {
    let temp = [...dates];
    let data = temp[ind];
    let formdata = new FormData();
    // formdata.append("id", knf_company_site_id?.value);
    formdata.append("knf_company_site_id", user_details?.knf_company_site_id);
    formdata.append("date", data?.date);
    formdata.append("start_time", data?.start_time);
    formdata.append("end_time", data?.end_time);
    post(URL.SPECIAL_DATE_STORE, formdata)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          getDateList(option, ind);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const sampleExcelDownload = () => {
    // get(URL.SAMPLE_DATE_EXCEL_DOWNLOAD)
    //   .then((res) => {})
    //   .catch((err) => {
    //     console.log("err", err);
    //   });

    try {
      const link = document.createElement("a");
      link.href = BASE_URL + URL.SAMPLE_DATE_EXCEL_DOWNLOAD;
      link.setAttribute("download", "");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log("error", error);
    }
  };

  const specialDateImport = () => {
    if (fileUpload?.name) {
      let formdata = new FormData();
      formdata.append("file", fileUpload);
      formdata.append("knf_company_site_id", user_details?.knf_company_site_id);
      post(URL.SPECIAL_DATE_IMPORT, formdata)
        .then((res) => {
          if (res?.status == "success") {
            getDateList();
            setFileUpload("");
            handleClose();
            if (res?.failed_rows?.length) {
              const groupedErrors = {};

              res.failed_rows.forEach((item) => {
                const error = item.errors[0];

                if (!groupedErrors[error]) {
                  groupedErrors[error] = [];
                }

                groupedErrors[error].push(item.row);
              });

              const message = Object.entries(groupedErrors)
                .map(([error, rows]) => {
                  return `Rows ${rows.join(", ")}: ${error} other dates are imported succesufully`;
                })
                .join("\n\n");

              toast.error(message);
            } else {
              toast.success(res?.message);
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Upload a File");
    }
  };

  return (
    <div className="dashRightView">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "week" ? "active" : ""}`}
          onClick={() => handleTab("week")}
        >
          Week days
        </button>
        <button
          className={`tab-btn ${activeTab === "special" ? "active" : ""}`}
          onClick={() => handleTab("special")}
        >
          Special Holidays
        </button>
      </div>

      <div>
        {activeTab == "week" && (
          <Slot
            superAdmin={superAdmin}
            days={days}
            setDays={setDays}
            handleSubmit={handleSubmit}
            handleCheckboxChange={handleCheckboxChange}
            selectedDays={selectedDays}
            getDayList={getDayList}
            getDateList={getDateList}
            option={user_details}
            setSelectedDays={setSelectedDays}
          />
        )}
        {activeTab == "special" && (
          <SpecialSlots
            superAdmin={superAdmin}
            setShowPopup={setShowPopup}
            dates={dates}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            setDates={setDates}
            handleDateSubmit={handleDateSubmit}
            option={option}
            getDateList={getDateList}
          />
        )}
      </div>

      <Modal show={showPopup} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title> Import Excel</Modal.Title>
        </Modal.Header>
        <div className="p-3">
          <button
            className="text-start cust-btn rounded-3 bg-primar p-2 d-grid  text-white"
            onClick={() => sampleExcelDownload()}
          >
            Sample Download
          </button>
          <div className="mt-4">
            <h6>Upload Excel</h6>
            <input
              type="file"
              className="form-control w-100 mt-3"
              accept=".xlsx, .xls, .csv"
              onChange={(e) => {
                setFileUpload(e.target.files[0]);
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end pt-2 mb-3 mx-5">
          <button
            className="cust-btn bg-primar text-white rounded-3 p-2 d-grid m-3"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            className="cust-btn bg-primar text-white rounded-3 p-2 d-grid m-3"
            onClick={() => specialDateImport()}
          >
            Submit
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default SlotMain;
